import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { categories } from "@/mocks/news";
import { siteInfo } from "@/mocks/site";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleModal from "@/components/feature/ArticleModal";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Extras from "./components/Extras";
import { useSeo } from "@/hooks/useSeo";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: siteInfo.brandFull,
      url: "https://rencaishu.cn/",
      slogan: siteInfo.slogan,
      email: siteInfo.email,
    },
    {
      "@type": "WebSite",
      name: siteInfo.brandFull,
      url: "https://rencaishu.cn/",
      description: siteInfo.desc,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://rencaishu.cn/?s={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "CollectionPage",
      name: "海角爆料今日快讯",
      url: "https://rencaishu.cn/",
      description: "海角爆料实时更新，今日新鲜快讯与热门事件进展第一时间同步，吃瓜追更抢先看。",
    },
  ],
};

export default function Home() {
  const location = useLocation();
  const [activeCat, setActiveCat] = useState("all");
  const [search, setSearch] = useState("");
  const [article, setArticle] = useState<NewsItem | null>(null);

  useSeo({
    title: "海角爆料 - 今日快讯 · 实时更新 · 热门事件抢先看",
    description:
      "海角爆料专注新鲜快讯与热门事件实时更新，今日快讯、实时动态、热门事件进展第一时间同步，覆盖娱乐、影视、综艺、科技圈与生活方式，吃瓜追更不错过任何节点。",
    keywords: "海角爆料,海角爆料最新,海角爆料今日,海角爆料实时,新鲜快讯,实时更新,热门事件,吃瓜追更",
    path: "/",
    jsonLd: orgJsonLd,
  });

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (!hash) return;
    const tick = setTimeout(() => {
      if (hash === "subscribe") {
        scrollToEl("subscribe");
        return;
      }
      const cat = categories.find((c) => c.key === hash);
      if (cat) {
        setActiveCat(cat.key);
        setSearch("");
        scrollToEl("feed");
      }
    }, 80);
    return () => clearTimeout(tick);
  }, [location.hash]);

  const scrollToEl = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const onKeyword = (w: string) => {
    setSearch(w);
    setActiveCat("all");
    const tick = setTimeout(() => scrollToEl("feed"), 60);
    return () => clearTimeout(tick);
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero onOpen={setArticle} onKeyword={onKeyword} />
        <Feed
          activeCat={activeCat}
          onCatChange={setActiveCat}
          search={search}
          onSearchChange={setSearch}
          onOpen={setArticle}
        />
        <Extras onOpen={setArticle} onKeyword={onKeyword} />
      </main>
      <Footer />
      <ArticleModal article={article} onClose={() => setArticle(null)} onSelect={setArticle} />
    </>
  );
}